import { render } from "./StartButton.vue?vue&type=template&id=3f1e6e0c&scoped=true"
import script from "./StartButton.vue?vue&type=script&lang=js"
export * from "./StartButton.vue?vue&type=script&lang=js"

import "./StartButton.vue?vue&type=style&index=0&id=3f1e6e0c&scoped=true&lang=css"

import exportComponent from "/Users/jipfens/Library/Mobile Documents/com~apple~CloudDocs/iProjects/lexis/lexis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1e6e0c"]])

export default __exports__